import { LOAD_MY_CHAMPIONSHIPS, UNAUTHENTICATED, LOAD_LEADERBOARD_FIRST_PAGE } from "../actions";
import { Championship, LeaderboardData } from "../types";

type Leaderboards = {
	[key: string]: LeaderboardData[];
};

export const initialState = {
	championships: null as Championship[],
	firstPages: {} as Leaderboards,
};

export type ChampionshipsState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_MY_CHAMPIONSHIPS: {
			const championships = action.data;

			return { ...state, championships };
		}

		case LOAD_LEADERBOARD_FIRST_PAGE: {
			let firstPages = state.firstPages;
			firstPages[action.uuid] = action.data;

			return { ...state, firstPages: { ...firstPages } };
		}

		case UNAUTHENTICATED: {
			return initialState;
		}

		default:
			return state;
	}
}
